import axios from "axios";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

async function resolve(promise) {
  let resolved = {
    data: null,
    error: null,
  };

  try {
    resolved.data = await promise;
  } catch (e) {
    console.log(e.code);
    if (e.code === "ERR_NETWORK") {
      toast.error("Problem with network connection..");
    }

    resolved.error = e.response ? e.response.data : e;
  }
  return resolved;
}

export async function signUp(username, email, password) {
  let data = {
    username: username,
    email: email,
    password: password,
  };

  return await resolve(
    axios
      .post(window.global.server_url + "/signup", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => res.data)
  );
}

export async function login(email, password) {
  let data = {
    email: email,
    password: password,
  };

  return await resolve(
    axios
      .post(window.global.server_url + "/login", data, {
        headers: {
          "content-Type": "application/json",
        },
      })
      .then((res) => res.data)
  );
}

export async function getuserdetail() {
  return await resolve(
    axios
      .get(window.global.server_url + "/current_user", {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function logout() {
  return await resolve(
    axios
      .delete(window.global.server_url + "/logout", {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function checklist() {
  return await resolve(
    axios
      .get(window.global.server_url + "/check_list", {
        headers: {
          "content-Type": "application/json",
        },
      })
      .then((res) => res.data)
  );
}

export async function upload_files(encrypted, name, list) {
  let data = {
    content: encrypted,
    name: name,
    checks: list,
  };

  return await resolve(
    axios
      .post(window.global.server_url + "/upload_file", data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function getarticle(curr) {
  let data = {
    c_id: curr.c_id && curr.c_id.trim() !== "" ? parseInt(curr.c_id) : null,
    exits:
      curr.exits !== undefined ? curr.exits.toString().toLowerCase() : null,
  };
  console.log(data);
  return await resolve(
    axios
      .get(window.global.server_url + "/article_reports", {
        params: data,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function article_details(id) {
  return await resolve(
    axios
      .get(window.global.server_url + `/article_details/${id}`, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function article_dash() {
  return await resolve(
    axios
      .get(window.global.server_url + `/article_dash/`, {
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => res.data)
  );
}

export async function download_files(state) {
  let data = {
    exits: state,
  };
  return await resolve(
    axios
      .get(window.global.server_url + `/download/`, {
        params: data,
        headers: {
          "content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        responseType: "blob",
      })
      .then((res) => res.data)
  );
}
